import StorageKeys from "../../../const/StorageKeys";
import CacheStorage from "../../../service/storage/CacheStorage";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { navigate } from "../../../service/navigation/Navigation";
import { FollowingBranchListModel } from "../../../model/notices/FollowingBranchListMode";
import ShowToast from "../../../widget/common/ui/Toast";

const FollowingListProvider = new (class FollowingListProvider {
  navigate = (url: any) => {
    navigate(url);
  };

  getFollowingBranchListAPI =
    async (): Promise<FollowingBranchListModel | null> => {
      ApiUrls.init();

      const accountId: string =
        CacheStorage.getValue(StorageKeys.account_id) ?? "0";
      const url: string = `${ApiUrls.baseUrl}notice/following_branch_list`;
      const body: any = {
        account_id: accountId,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const followingBranchListModel: FollowingBranchListModel = response;
          return followingBranchListModel;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };

  deleteFollowingAPI = async (ids: Array<string>): Promise<boolean> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}notice/unfollow_branches`;
    const body: any = {
      account_id: accountId,
      branch_id_list: ids.join(","),
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };
})();

export default FollowingListProvider;
